<template>
    <div class="background" >

    <div style="height:40px"></div>
    <div class="font-xll">
        <p>YOYOVPN</p>
        <p style="margin-top: 20px;">Unblocked | Safe | Stable</p>
        <div style="height:20px"></div>
        <p>Because of you in, so the wonderful world be.</p>
    </div>
    <div style="height:100px"></div>
    <div class="dl-container-center">
        <div class="dl-container">
            <div>
                <!-- <img src="../assets/android.png" height="20px" width="20px"></img> -->
                <div class="dl-htn">
                    <p class="p" @click="dlApk">Download for Android</p>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div class="dl-htn">
                    <p class="p" @click="dlWindow">Download for Windows</p>
                    <p class="dl-htn-ps">*Under construction</p>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
  name: 'navbar',
  components: {
  },
  data () {
    return {
        error: null,
        data: null
    }
  },
  mounted() {
  },
  methods: {
    dlApk() {
      alert('下载链接: ' + process.env.VUE_APP_DOWNLOAD_URL)
    },
    dlWindow() {
      alert("Under construction, please stay tuned")
    }
  }
}
</script>

<style scoped>
.background {
    position: fixed;
    width: 100%;
    height: 100%;
    background-image: url('../assets/weee.jpg');
    opacity: 0.8;
    background-size: cover;
    background-position: center;
    flex: 1;
}
.font-xll {
    font-family: 微软雅黑;
    font-size: 22px;
    color:#faf6f6;
}
.dl-container {
    margin: 0 auto;
    font-family: 微软雅黑;
    font-size: 15px;
    /*float: left;*/
    div {
        /*float: inline-start;*/
        display: block;
    }
}

.dl-container-center {
    margin: 0 auto;
    font-family: 微软雅黑;
    font-size: 15px;
    width: 200px;
    height: 200px;
    display: block;

}

.dl-htn {
    /*display: inline; */
    /*position:relative;*/
    align-items: center;
    justify-content: center;
    display: flex;
    color: #faf6f6;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #07b97e9c;
    height: 40px;
    border-radius: 20px;
    border:solid 1px white;
   .p {
        margin-top: 10px;
   }
}
.dl-htn:hover {
    background-color: #07b97e9c;
    box-shadow: 1px 1px 1px 1px  #07b97e54;
    border:solid 1px rgba(224, 13, 13, 0.596);
    color: #0a07d3;

}
.dl-htn-ps {
    margin-top: 8px;
    font-size: 12px;
    color: #faf6f6;
   }
</style>
